import React from "react";

function LoadingUi() {
  return (
    <div>
          {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid d-flex align-items-center justify-content-center" style={{height:"calc(100vh - 0px)"}}>
      <div className="spinner-border" role="status" style={{fontWeight:"400"}}>
        <span className="sr-only">Loading...</span>
      </div>
      </div>
      </section>
      </div>
    </div>
  );
}

export default LoadingUi;
